module.exports = "/_next/static/images/video_id_7185697470670966062-e01912348bb22c21e90e2b43b3a8bc87.jpg";